export const NetworkCode = {
  BTC: "BTC",
  ETH: "ETH",
  POLYGON: "POLYGON",
  BSC: "BSC",
  SOL: "SOL",
  TRON: "TRON",
  ARBITRUM: "ARBITRUM",
  OPTIMISM: "OPTIMISM",
  BASE: "BASE",
  AVALANCHE: "AVALANCHE",
  PHANTOM: "PHANTOM",
} as const;

export type NetworkCode = (typeof NetworkCode)[keyof typeof NetworkCode];

export const NetworkType = {
  MAINNET: "MAINNET",
  TESTNET: "TESTNET",
} as const;

export type NetworkType = (typeof NetworkType)[keyof typeof NetworkType];

// export type BlockchainNetwork = {
//   id: string;
//   name: string;
//   code: NetworkCode;
//   chainId: string | null;
//   coinSymbol: string;
//   rpcUrl: string | null;
//   wsUrl: string | null;
//   explorerUrl: string | null;
//   confirmations: number;
//   decimals: number;
//   isEvm: boolean;
//   isUtxo: boolean;
//   supportsTokens: boolean;
//   enabled: boolean;
//   depositEnabled: boolean;
//   withdrawEnabled: boolean;
//   priority: number;
//   icon: string | null;
//   feeAssetSymbol: string;
//   supportsMemo: boolean;
//   supportsTag: boolean;
//   networkType: NetworkType;
//   createdAt: Date;
//   updatedAt: Date;
//   deletedAt: Date | null;
// };

export interface BlockchainNetworkCounts {
  assets: number;
  tokens: number;
  addresses: number;
  blockchainDeposits: number;
  blockchainWithdrawals: number;
}

export interface BlockchainNetwork {
  id: string;
  name: string;
  code: NetworkCode;
  chainId: string | null;
  coinSymbol: string;
  confirmations: number;
  decimals: number;
  explorerUrl: string | null;
  rpcUrl: string | null;
  wsUrl: string | null;
  feeAssetSymbol: string;
  icon: string | undefined;
  enabled: boolean;
  depositEnabled: boolean;
  withdrawEnabled: boolean;
  isEvm: boolean;
  isUtxo: boolean;
  supportsTokens: boolean;
  supportsMemo: boolean;
  supportsTag: boolean;
  networkType: NetworkType;
  priority: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  _count: BlockchainNetworkCounts;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface BlockchainNetworkResponse {
  data: BlockchainNetwork[];
  meta: PaginationMeta;
}

export interface BlockchainNetworkQuery {
  page?: number;
  limit?: number;
  search?: string;
  enabled?: boolean;
  networkType?: NetworkType;
  architecture?: "ALL" | "EVM" | "UTXO";
  supportsTokens?: boolean;
  sortBy?: "priority" | "name" | "createdAt";
  order?: "asc" | "desc";
}

export interface CreateBlockchainNetworkDto {
  name: string;
  code: string;
  coinSymbol: string;
  chainId: string | null;
  feeAssetSymbol: string;
  explorerUrl: string | null;
  rpcUrl: string | null;
  wsUrl: string | null;
  decimals: number;
  confirmations: number;
  priority: number;
  networkType: "MAINNET" | "TESTNET";
  enabled: boolean;
  depositEnabled: boolean;
  withdrawEnabled: boolean;
  isEvm: boolean;
  isUtxo: boolean;
  supportsTokens: boolean;
  supportsMemo: boolean;
  supportsTag: boolean;
}

export interface BlockchainNetworkFilters {
  search: string;
  enabled: "ALL" | "ACTIVE" | "DISABLED";
  networkType: "ALL" | NetworkType;
  architecture: "ALL" | "EVM" | "UTXO";
  supportsTokens: "ALL" | "YES" | "NO";
  sortBy: "priority" | "name" | "createdAt";
  order: "asc" | "desc";
}

export type UpdateBlockchainNetworkDto = Partial<CreateBlockchainNetworkDto>;
